import { useState, useEffect } from 'react';
import { A27, A27Input, A27Output } from 'api/U002';
import { useAuth } from 'hooks/useAuth';
import { FetchError } from 'api/API';

export function useGetAgreementText(param: A27Input): [A27Output | null, boolean, Error | null] {
  const auth = useAuth();
  const [loading, setLoading] = useState<boolean>(true);
  const [consent, setConsent] = useState<A27Output | null>(null);
  const [err, setError] = useState<Error | null>(null);

  const FetchSpecificUseConsent = async (param: A27Input, cancellation: AbortSignal) => {
    const json = await A27(param, cancellation);
    return json;
  };

  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;
    async function fetch() {
      if (!param.audition_id) {
        setLoading(false);
        return;
      }
      try {
        setLoading(true);
        setError(null);
        const specificUseConsent = await FetchSpecificUseConsent({ ...param }, signal);
        if (!signal.aborted) {
          setConsent(specificUseConsent);
          setLoading(false);
        }
      } catch (err) {
        if (err instanceof DOMException && err.message === 'signal is aborted without reason')
          return;
        console.error({ err });
        if (!signal.aborted) {
          if (err instanceof FetchError) {
            const errorData = await err.response.json();
            const flooredError = new Error(errorData.message || `HTTP ERROR: ${err.message}`);
            setError(flooredError);
          } else {
            const flooredError = new Error(`unknown error. ${err}`);
            setError(flooredError);
          }
          setLoading(false);
        }
      }
    }

    fetch();
    return () => {
      controller.abort();
    };
  }, [param.audition_id, param.lang, auth.username]);

  return [consent, loading, err];
}
